import { render, staticRenderFns } from "./GradesList.vue?vue&type=template&id=02446c0b&scoped=true&"
import script from "./GradesList.vue?vue&type=script&lang=js&"
export * from "./GradesList.vue?vue&type=script&lang=js&"
import style0 from "./GradesList.vue?vue&type=style&index=0&id=02446c0b&prod&lang=scss&"
import style1 from "./GradesList.vue?vue&type=style&index=1&id=02446c0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02446c0b",
  null
  
)

export default component.exports